import { useEffect } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useClickOutside = (
  ref,
  handler,
) => {
  useEffect(() => {
    const listener = (event) => {
      if (handler) {
        if (Array.isArray(ref)) {
          const filteredRefs = ref.filter((_ref) => {
            if (_ref.current) {
              return _ref.current?.contains(event.target);
            }
            return true;
          });

          if (filteredRefs.length) {
            return;
          }

          handler(event);
        } else {
          if (!ref.current || ref.current.contains(event.target)) {
            return;
          }
          handler(event);
        }
      }
    };

    if (handler) {
      document.addEventListener('mousedown', listener);
    }

    return () => {
      if (handler) {
        document.removeEventListener('mousedown', listener);
      }
    };
  }, [ref, handler]);
};
